// Room Door Lock (102) battery — reported by the lock over MQTT only.
//
// The firmware's contract (2026-09-29): the lock reads battery on Tuya DP 12
// and says it on `<uid>/client` in three places —
//
//   live       [uid]Battery 90%#Lock          [uid]Battery 15% LOW#Lock
//   on demand  GETBATTERY -> [uid]Battery 90% | [uid]Battery 15% LOW
//                         | [uid]Battery unknown (not reported yet)
//   in STATUS  [uid]No event, Battery 90%     [uid]Unlock App#Lock, Battery 90%
//
// Rule: /Battery\s+(\d+)%/ anywhere in the body; " LOW" right after the % means
// <= 20 %. The firmware appends LOW itself, but the threshold is checked here
// too so a frame without the word still warns.
//
// ⚠️ NOT PERSISTED. Battery goes over MQTT only (deliberately never written to
// DevicesInstalled, so it can't overwrite the lock's Status column). An app
// opened while the lock is asleep has nothing to show until it answers
// GETBATTERY — the screen says "unknown", never a stale guess.

export const LOW_BATTERY_PERCENT = 20;
export const CMD_GET_BATTERY = 'GETBATTERY';

/** Only the Room Door Lock's firmware speaks this. */
export const supportsBattery = (deviceId) => Number(deviceId) === 102;

/**
 * -> { percent, low } | { unknown: true } | null (not a battery message).
 * Accepts the raw frame or the body already stripped of [uid] / #src.
 */
export function parseBattery(message) {
  const body = String(message ?? '').replace(/^\[[^\]]*\]/, '');
  if (/Battery\s+unknown/i.test(body)) return { unknown: true };
  const m = /Battery\s+(\d{1,3})%(\s*LOW)?/i.exec(body);
  if (!m) return null;
  const percent = Math.max(0, Math.min(100, Number(m[1])));
  return { percent, low: !!m[2] || percent <= LOW_BATTERY_PERCENT };
}
